<template>
    <div class="MMyQuestion" v-if="init">
        <pull :pull="pull" :page="page" @getList="getList">
            <NoData v-if="!dataList.length"></NoData>
            <div class="question_bank_warp">
                <div @click="handQuestionClick(item)" v-for="(item, index) in dataList" :key="index" class="question_item_box">
                    <div class="left"><img class="img" v-lazy="item.coverurl" alt=""></div>
                    <div class="right">
                        <div class="subject">{{item.subject}}</div>
                        <div class="schedule">
                            <div class="progress">
                                <van-progress v-if="item.status===1" :percentage="percentage(item)" />
                            </div>
                            <div class="progressName">
                                <div v-if="item.status===10">已完成</div>
                                <div v-if="item.status===0">立即考试</div>
                                <div v-if="item.status===1">
                                    <span>考试进度</span>
                                    <span class="total">{{item.finishcount}}/{{item.totalcount-1}}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </pull>
    </div>
</template>

<script>
import {getAllQuestionbankByUser} from 'api/examApi'
import {mapGetters, mapActions} from 'vuex'
import NoData from 'views/mobile/components/noData/noData'
import Pull from 'views/mobile/components/pull/pull'
export default {
    name: 'MMyQuestion',
    data() {
        return {
            // testImg: 'http://innertest.img.capwhale.com/kmc/content/20200211/4ac47838ea9b41219d765b65e23241c4',
            init: false,
            dataList: [],
            param: {},
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            }
        }
    },
    mounted() {
        this.getList()
        this.setNoDataTip('暂无题库')
        document.title = '我的题库'
        if (!this.refresh) {
            this.getList()
        }
    },
    activated () {
        if (this.refresh) {
            this.getList()
            this.setRefresh(false)
        }
    },
    methods: {
        // 点击我的题库列表单个题库跳转到考试记录页面
        handQuestionClick(val) {
            // console.log(val)
            this.setRefresh(true)
            this.$router.push({name: 'MMyExam',query: {bankid: val.courseid}})
        },
        // 获取题库列表
        getList() {
            this.setLoading(true)
            getAllQuestionbankByUser({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.init = true
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.dataList = data.data.content
                    } else {
                        this.dataList = this.dataList.concat(data.data.content)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setRefresh',
            'setNoDataTip'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        percentage () {
            return function(obj) {
                obj.totalcount = obj.totalcount | 1
                return  parseInt((obj.finishcount / obj.totalcount) * 100)
            }
        },
        ...mapGetters(['refresh'])
    },
    components: {
        NoData,
        Pull
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
        opacity: 0
    }
    .MMyQuestion {
        font-family:PingFangSC-Regular,PingFang SC;
        background:rgba(245,247,250,1);
        min-height: 100vh;
        color: #333;
        .noData{
            height: 100vh;
            background: #fff;
        }
        .question_bank_warp {
            background:rgba(255,255,255,1);
            padding: 0 0.32rem;
            .question_item_box {
                display: flex;
                justify-content: flex-start;
                font-size:0.28rem;
                font-weight: 600;
                padding: 0.28rem 0;
                background: $c-white;
                .left{
                    min-width:2.6rem;
                    max-width: 2.6rem;
                    width: 2.6rem;
                    height: 1.46rem;
                    margin-right:0.2rem;
                    .img{
                        width: 100%;
                        height: 100%;
                        border-radius: 0.04rem;
                    }
                }
                .right{
                    width: 4.84rem;
                    .subject{
                        height: 0.8rem;
                        line-height: 0.4rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .schedule{
                        color: $c-grey;
                        font-size: 0.24rem;
                        .progress{
                            margin: 0.12rem 0;
                            height: 0.08rem;
                        }
                        .progressName{
                            margin-top: 0.12rem;
                            .total{
                                margin-left: 0.12rem;
                            }
                        }
                    }
                }
            }
            .question_item_box+.question_item_box{
                border-top: 0.01rem solid $line;
            }
        }
        .van-progress__pivot{
            display: none;
            max-width: 100%!important;
        }
        .van-progress__portion{
            background: $c-blue;
            max-width: 100%!important;
        }
    }
</style>